
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl, SafeHtml } from '@angular/platform-browser';

import { Router, ActivatedRoute, NavigationStart, Event as NavigationEvent } from '@angular/router';
import {NetworkHelperService} from '../../../_services/network-helper.service';
import {FORMS, API, CODFUNC, PAGE, GENERALES} from '../../../_config/strings';
import Swal from 'sweetalert2';
import { IMAGEVIEWER_CONFIG, ImageViewerConfig } from '@hallysonh/ngx-imageviewer';
import {Usuario} from '../../../_model/Usuario';
import {Cliente} from '../../../_model/Cliente';
import swal from 'sweetalert2';
import * as moment from 'moment';
import {Subject} from 'rxjs/Subject';
import { ChatService } from '../../../_services/chat.service';
import {Chart} from 'chart.js';
// Galería de imágenes
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
// Galería de imágenes

declare var $: any;

@Component({
  selector: 'app-sistema-tickets',
  templateUrl: './sistema-tickets.component.html',
  styleUrls: ['./sistema-tickets.component.scss']
})
export class SistemaTicketsComponent implements OnInit {

  // Galería de imágenes
  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];
  // Galería de imágenes

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  FORMS: any;
  API: any;
  GENERALES: any;
  PAGE: any;
  LineChart;
  LineChart2;

  public usuario: Usuario = new Usuario();
  public cliente: Cliente;
  public innerHtml: SafeHtml;

  teamViewerId = 0;
  teamViewerPass = '';
  modemSSID = '';
  modemPass = '';
  conceptoId = 0;
  descripcion = '';
  ticketId;
  folioFactura = 0;
  conceptoFacturaId = 0;
  colorTicketTitulo;
  elAidiDelTicket;

  arrayImgTickets;
  imgTickets;

  banderaImgTickets = false;

  boolfolioFactura = false;
  boolTipoUsuario = false;

  // Detalles
  detallesAsesor;
  detallesConcepto;
  detallesSolicitud;
  detallesSucursal;
  detallesEstatusEstatus;
  detallesFechaSolicitud = moment();
  detallesFechaSolucion = moment();
  detallesFechaDiferencia;
  detallesFolioFactura;
  detallesTeam;
  detallesTeamPass;
  detallesModem;
  detallesModemPass;

  arrayTickets = [];
  arrayTicketsReverse = [];
  arrayComentarioTicket = [];

  radioPreguntaUno;
  radioPreguntaDos;
  radioPreguntaTres;

  comentarioTicket = '';
  mostrarComentario = false;

  banderaDTrigger = true;

  sumaAtendidos = 0;
  sumaCumplimiento = 0;
  sumaPendientes = 0;
  sumaResueltos = 0;
  sumaResueltosYEvaluados = 0;
  ticketsTotal = 0;

  sumaPorcentajeTiempo;
  sumaTiempoConcepto;
  sumaPorcentajeEncuesta;

  procentajeTotal;

  permisoSoporte;
  ticketIdUrl = 0;
  banderaOtrosDocs = false;
  documentosImg = [];
  datosImagenes;
  banderaArchivosImagenes = false;

  archivosImagenes;
  constructor(
    private activatedRoute: ActivatedRoute,
    private network: NetworkHelperService,
    private rutas: Router,
    private chat: ChatService,
    private sanitizer: DomSanitizer
  ) {
    this.FORMS = FORMS;
    this.API = API;
    this.GENERALES = GENERALES;
    this.PAGE = PAGE;
    this.usuario = JSON.parse( localStorage.getItem('usuario') );
    this.permisoSoporte = this.usuario.permisos.find(e => e.codigoFuncionalidad === 'TICVER');
    this.ticketIdUrl = Number(this.activatedRoute.snapshot.paramMap.get('idTicket'));
  }

  ngOnInit() {
    if ( this.usuario.rol === 'SOPORTE' || this.permisoSoporte) {
      this.soporteObtenerTickets();
      this.boolTipoUsuario = true;
      if(this.ticketIdUrl !== 0)
      {
      this.detallesTicket (this.ticketIdUrl);
      $("#tickeDetalles").modal('show');
      }
    } else {
      this.usuarioObtenerTickets();
      this.boolTipoUsuario = false;
      if(this.ticketIdUrl !== 0)
      {
      this.detallesTicket (this.ticketIdUrl);
      $("#tickeDetalles").modal('show');
      }
    }

    $('.letras').on('input', function (e) {
      if (!/^[a-z0-9áéíóúüñ.,-_/]*$/i.test(this.value)) {
          // [ a-z0-9áéíóúüñ]
          this.value = this.value.replace(/[^a-z0-9áéíóúüñ.,-_/]+/ig, '');
      }
    });

    // Galería de imágenes
    this.galleryOptions = [
      {
        width: '100%',
        height: '400px',
        thumbnailsColumns: 4,
        imageAnimation: NgxGalleryAnimation.Slide,
        previewFullscreen: true,
        previewZoom: true,
        previewZoomStep: 0.3,
        previewZoomMax: 4

      },
      // max-width 800
      {
        breakpoint: 800,
        width: '100%',
        height: '600px',
        imagePercent: 80,
        thumbnailsPercent: 20,
        thumbnailsMargin: 20,
        thumbnailMargin: 20
      },
      // max-width 400
      {
        breakpoint: 400,
        preview: false
      }
    ];
    // Galería de imágenes
    this.inverse();
  }
  modalGenerarTicket(){
    if ( this.usuario.rol !== 'SOPORTE') {
      let sinPendientes = this.arrayTickets.filter(e => e.estusCode === 'SOPRESU');
     // console.log(sinPendientes);
      if(sinPendientes.length !== 0)
      {
        Swal({
          title: 'Atencion',
          text: 'Tienes Tickets sin evaluar, dependemos de ti para dar un mejor servicio. ¡Evaluanos por favor!',
          type: 'info',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'No me importa!',
          cancelButtonText: 'Esta bien, los evaluo'
        }).then((result) => {
          if (result.value) {
             $("#tickeGenerar").modal('show');
          }
        });
      }
      else {
        $("#tickeGenerar").modal('show');
      }
    } else {
      $("#tickeGenerar").modal('show');
    }
  }

  obtenderResultadosTickets() {
    this.network.callSecureService(
      this.API.user.tickets + '/' + 'resultados',
      'GET',
      null
    ).subscribe((response: any) => {
      //console.log(response);
      this.sumaAtendidos = response.Mensaje.sumaAtendidos;
      this.sumaPendientes = response.Mensaje.sumaPendientes;
      this.sumaResueltos = response.Mensaje.sumaResueltos;
      this.sumaResueltosYEvaluados = response.Mensaje.sumaResueltosYEvaluados;
      this.ticketsTotal = this.sumaAtendidos + this.sumaPendientes + this.sumaResueltos + this.sumaResueltosYEvaluados;
      this.sumaPorcentajeEncuesta = response.Mensaje.sumaPorcentajeEncuesta / this.sumaResueltosYEvaluados;
      this.sumaTiempoConcepto = (response.Mensaje.sumaTiempoConcepto  * 100 ) / response.Mensaje.sumaPorcentajeTiempo;
      console.log(this.sumaTiempoConcepto);
      if( this.sumaTiempoConcepto >= 100)
      {
        this.sumaTiempoConcepto = 98;
      }
      this.sumaCumplimiento = (response.Mensaje.sumaCumplimiento * 100) / this.arrayTickets.length;
      this.procentajeTotal = (this.sumaPorcentajeEncuesta + this.sumaTiempoConcepto + this.sumaCumplimiento) / 3;
      this.grafica ();
    }, err => {
      console.log(err);
    });
  }

  soporteObtenerTickets () {
    this.network.callSecureService(
      this.API.user.tickets + '/' + this.API.user.listar + '/' + this.API.user.soporte,
      'GET',
      null
      ).subscribe((response: any) => {
        //console.log( response );
        if ( response.Estatus === 200 ) {
          const listarTicketsSoporte = response.Mensaje.reverse();
          let incrementando = 1;
          for (const responseTickets of listarTicketsSoporte) {
            this.arrayTickets.push({
              aidi: responseTickets.ticketId,
              id: incrementando++,
              concepto: responseTickets.concepto,
              sucursal: responseTickets.sucursalNombre,
              usuario: responseTickets.usuario,
              asesor: responseTickets.asesor,
              estatusColor: responseTickets.estatus.color,
              estatusNombre: responseTickets.estatus.nombre,
              estusCode: responseTickets.estatus.estatus
              
            });
          }
        }
        if (this.banderaDTrigger) {
          this.banderaDTrigger = false;
          this.dtTrigger.next();
        }
        this.obtenderResultadosTickets();
      }, err => {
        console.log( err );
        Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
      }
    );
  }

  usuarioObtenerTickets () {
    this.network.callSecureService(
      this.API.user.tickets + '/' + this.API.user.listar + '/' + this.API.user.usuario,
      'GET',
      null
    ).subscribe((response: any) => {
     // console.log( response );
      if ( response.Estatus === 200 ) {
        const listarTicketsUsuario = response.Mensaje.reverse();
        // console.log( listarTicketsUsuario );
        let incremento = 1;
        for (const responseTickets of listarTicketsUsuario) {
          this.arrayTickets.push({
            aidi: responseTickets.ticketId,
            id: incremento++,
            concepto: responseTickets.concepto,
            sucursal: responseTickets.sucursalNombre,
            usuario: responseTickets.usuario,
            asesor: responseTickets.asesor,
            estatusColor: responseTickets.estatus.color,
            estatusNombre: responseTickets.estatus.nombre,
            estusCode: responseTickets.estatus.estatus
          });
        }
      }
      if (this.banderaDTrigger) {
        this.banderaDTrigger = false;
        this.dtTrigger.next();
      }
    }, err => {
      console.log(err);
      Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
    });
  }

  inverse() {
    this.arrayTicketsReverse = this.arrayTickets.reverse();
    // console.log( this.arrayTicketsReverse );
  }

  enviarTicket () {
    if ( !this.conceptoId ) {
      Swal('Incompleto', 'Por favor indica el concepto del Ticket', 'warning');
    } else {
      const jSONTicket = {
        teamId: this.teamViewerId,
        passTeam: this.teamViewerPass,
        modemSsid: this.modemSSID,
        passModem: this.modemPass,
        conceptoId: this.conceptoId,
        solicitud: this.descripcion,
        folioFactura: this.folioFactura,
        conceptoFacturaId: this.conceptoFacturaId
      };
      this.network.callSecureService(
        this.API.user.tickets + '/' + this.API.user.crear,
        'POST',
        jSONTicket
        ).subscribe((response: any) => {
          //console.log( response );
          if ( response.Estatus === 201 ) {
            // --
            const envioCaptura: FormData = new FormData();
            const fileUpload = $('.archivoCaptura');
            for (const archivo of fileUpload[0].files) {
              envioCaptura.append(archivo.name, archivo);
            }
            envioCaptura.append('ticketId', response.Mensaje.id);
            this.network.callSecureService(
              this.API.user.tickets + '/' + this.API.user.imagenes + '/' + this.API.user.subir,
              'POST',
              envioCaptura
            ).subscribe(( responseForm: any) => {
              //console.log( responseForm );
            }, err => {
              console.log( err );
              Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
            });
            // --
            Swal('Correcto', response.Mensaje.strings, 'success');
            // == Targets de notificación ==
            let targets = response.Mensaje.notificacion;
            targets.forEach(e => {
              const target = e.target;
              const id = e.id;
              let notificacionString =  'El usuario ' + this.usuario.userName + ' ha realizado un nuevo ticket.';
              let url = 'tickets/'+id;
              this.sendMessageTest(target, notificacionString, url, id);
            });
            // == Targets de notificación ==
            if ( jSONTicket.conceptoId == 17 ) {
              const target = 'JuanS';
              const id = targets[0].id;
              const notificacionString =  'El usuario ' + this.usuario.userName + ' ha realizado un nuevo ticket.';
              const url = 'tickets/'+id;
              this.sendMessageTest(target, notificacionString, url, id);
            }
            // this.rutas.navigate(['dashboard']);
            this.arrayTickets = [];
            if ( this.usuario.rol !== 'SOPORTE' ) {
              this.usuarioObtenerTickets();
            } else {
              this.soporteObtenerTickets();
            }
            /*setTimeout(() => {
              location.reload();
            }, 100);
            */
            // this.ngOnInit();
          }
        }, err => {
          console.log(err);
          Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
        }
      );
      this.teamViewerId = 0;
      this.teamViewerPass = '';
      this.modemSSID = '';
      this.modemPass = '';
      this.conceptoId = 0;
      this.descripcion = '';
      this.folioFactura = 0;
      this.conceptoFacturaId = 0;
    }
  }

  detallesTicket (ticketAidi) {
    this.documentosImg = [];
    this.arrayComentarioTicket = [];
    const JSONDETALLETICKET = {
      ticketId: ticketAidi
    };
    this.network.callSecureService(
      this.API.user.tickets + '/' + this.API.user.detalles,
      'POST',
      JSONDETALLETICKET
      ).subscribe((response: any) => {
        console.log( response );
        this.elAidiDelTicket = response.Mensaje.ticketId;
        for(let mensaje of response.Mensaje.comnetarios)
        {
          let tipo = mensaje.comentario.slice(-3);
          if(tipo === 'jpg' || tipo === 'png' || tipo === 'peg')
          {
            this.arrayComentarioTicket.push({
              tipo: 'IMAGEN',
              comentario: {
                comentario: this.API.imgComentariosTickets + mensaje.comentario,
                comentarioId: mensaje.comentarioId,
                fecha: mensaje.fecha.split("T")[0],
                hora: mensaje.fecha.split("T")[1].split("+")[0],
                usuario: {
                  imagenPerfil: mensaje.usuario.imagenPerfil,
                  username: mensaje.usuario.username,
                  usuarioId: mensaje.usuario.usuarioId
              }
            }
            });
          }
          else {
            this.arrayComentarioTicket.push({
              tipo: 'TEXTO',
              comentario: {
                comentario: mensaje.comentario,
                comentarioId: mensaje.comentarioId,
                fecha: mensaje.fecha.split("T")[0],
                hora: mensaje.fecha.split("T")[1].split("+")[0],
                usuario: {
                  imagenPerfil: mensaje.usuario.imagenPerfil,
                  username: mensaje.usuario.username,
                  usuarioId: mensaje.usuario.usuarioId
              }
            }
            });
          }
        }
        
        console.log( this.arrayComentarioTicket );
        this.imgTickets = response.Mensaje.imagenes;
        
        let banderaDocs = 0;
        let banderaImgs = 0;
        let arrayTemporal = [];
        for (const imagen of this.imgTickets) {
          const subString = imagen.ruta.slice(-3);
          
          if(subString === 'jpg' || subString === 'png' || subString === 'peg')
          {
            banderaImgs = banderaImgs + 1;
            arrayTemporal.push({
              small: this.API.imagenesTickets + imagen.ruta,
              medium: this.API.imagenesTickets + imagen.ruta,
              big: this.API.imagenesTickets + imagen.ruta,
            });
          } else{
              banderaDocs = banderaDocs + 1;
              this.documentosImg.push({
                url: this.API.imagenesTickets + imagen.ruta
              });
          }
        }
          if ( banderaDocs > 0 ) {
            this.banderaOtrosDocs = true;
          } else{
            this.banderaOtrosDocs = false;
          }
          if(banderaImgs > 0)
          {
            this.banderaImgTickets = true;
          }
          else {
            this.banderaImgTickets = false;
          }
        
        this.galleryImages = arrayTemporal;
        this.detallesAsesor = response.Mensaje.asesor;
        this.detallesConcepto = response.Mensaje.concepto;
        this.detallesSolicitud = response.Mensaje.solicitud;
        this.detallesSucursal = response.Mensaje.sucursalNombre;
        this.colorTicketTitulo = response.Mensaje.estatus.color;
        this.detallesEstatusEstatus = response.Mensaje.estatus.estatus;
        this.detallesFechaSolicitud = moment(response.Mensaje.fechaSolicitud);
        this.detallesFechaSolucion = moment(response.Mensaje.fechaSolucion);
        this.detallesFechaDiferencia = moment.duration(this.detallesFechaSolucion.diff(this.detallesFechaSolicitud)).asMinutes();
        this.detallesFolioFactura = response.Mensaje.folioFactura;
        this.detallesTeam = response.Mensaje.idTeam;
        this.detallesTeamPass = response.Mensaje.passTeam;
        this.detallesModem = response.Mensaje.modemSsid;
        this.detallesModemPass = response.Mensaje.passModem;
      }, err => {
        console.log( err );
        Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
      }
    );
  }

  atendiendoTicket () {
    const JSONIDTICKET = {
      ticketId: this.elAidiDelTicket
    };
    this.network.callSecureService(
      this.API.user.tickets + '/' + this.API.user.atendiendo,
      'POST',
      JSONIDTICKET
    ).subscribe((response: any) => {
     // console.log( response );
      if ( response.Estatus === 201 ) {
        Swal('Correcto', response.Mensaje.strings, 'success');
        // == Targets de notificación ==
        let targets = response.Mensaje.notificacion;
        targets.forEach(e => {
            const target = e.target;
            const id = e.id;
            let notificacionString =  'El usuario ' + this.usuario.userName + ' está atendiendo el problema.';
            let url = 'tickets/'+this.elAidiDelTicket;
            this.sendMessageTest(target, notificacionString, url, id);
        });
        // == Targets de notificación ==
        // this.rutas.navigate(['/tickets']);
        this.arrayTickets = [];
          if ( this.usuario.rol !== 'SOPORTE' ) {
            this.usuarioObtenerTickets();
          } else {
            this.soporteObtenerTickets();
          }
          this.detallesTicket(this.elAidiDelTicket);
      }
    }, err => {
      console.log( err );
      Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
    });
  }

  ticketResuelto () {
    this.detallesFechaDiferencia = moment.duration(moment().diff(this.detallesFechaSolicitud)).asMinutes();
   // console.log( this.detallesFechaDiferencia );
    const JSONTIKCETRESUELTO = {
      ticketId: this.elAidiDelTicket,
      tiempo: this.detallesFechaDiferencia
    };
    this.network.callSecureService(
      this.API.user.tickets + '/' + this.API.user.resuelto,
      'POST',
      JSONTIKCETRESUELTO
    ).subscribe(( response: any ) => {
      if ( response.Estatus === 201 ) {
        Swal('Correcto', response.Mensaje.strings, 'success');
        // == Targets de notificación ==
        let targets = response.Mensaje.notificacion;
        targets.forEach(e => {
            const target = e.target;
            const id = e.id;
            let notificacionString =  'El usuario ' + this.usuario.userName + ' ha resuelto tu problema.';
            let url = 'tickets/'+this.elAidiDelTicket;
            this.sendMessageTest(target, notificacionString, url, id);
        });
        // == Targets de notificación ==
        // this.rutas.navigate(['/tickets']);
        this.arrayTickets = [];
        if ( this.usuario.rol !== 'SOPORTE' ) {
          this.usuarioObtenerTickets();
        } else {
          this.soporteObtenerTickets();
        }
        this.detallesTicket(this.elAidiDelTicket);
      }
    }, err => {
      console.log( err );
      Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
    });
  }

  evaluarServicio () {
    const JSONEVALUAR = {
      ticketId: this.elAidiDelTicket,
      servicio: this.radioPreguntaUno,
      tiempoRespuesta: this.radioPreguntaDos,
      solucion: this.radioPreguntaTres,
      tiempo: this.detallesFechaDiferencia
    };
    this.network.callSecureService(
      this.API.user.tickets + '/' + this.API.user.evaluar,
      'POST',
      JSONEVALUAR
    ).subscribe((response: any) => {
      Swal('Correcto', response.Mensaje.strings, 'success');
      this.arrayTickets = [];
      if ( this.usuario.rol !== 'SOPORTE' ) {
        this.usuarioObtenerTickets();
      } else {
        this.soporteObtenerTickets();
      }
      this.detallesTicket(this.elAidiDelTicket);
    }, err => {
      console.log( err );
      Swal('Error' + err.error.error.code, err.error.error.exceltion[0].message, 'error');
    });
  }

  conceptoAdmin () {
    if ( Number(this.conceptoId) === 1 ) {
      this.boolfolioFactura = true;
    } else {
      this.boolfolioFactura = false;
    }
  }

  dameElRadio () {
    // console.log( this.radioPreguntaUno );
    // console.log( this.radioPreguntaDos );
    // console.log( this.radioPreguntaTres );
    if ( !this.radioPreguntaDos ) {
      Swal('Incompleto', 'Te falta la pregunta dos', 'error');
    }
  }

  comentarTickets () {
    if(this.banderaArchivosImagenes)
    {
      this.comentarioImagen();
      if(this.comentarioTicket !== '')
      {
      this.comentarioText();
      }
    } else {
      if(this.comentarioTicket !== '')
      {
      this.comentarioText();
      }
    }
  }

  comentarioImagen()
  {
    const formImagenes = new FormData();
    formImagenes.append('ticketId', this.elAidiDelTicket);
    for (let imagen of this.archivosImagenes)
    {
      formImagenes.append(imagen.name, imagen);
    }

    this.network.callSecureService(
      this.API.user.tickets + '/' + this.API.user.comentar + '/' + this.API.user.imagenes,
      'POST',
      formImagenes
    ).subscribe(( response: any ) => {
     // console.log( response );
      if ( response.Estatus === 201 ) {
        //Swal('Correcto', response.Mensaje.strings, 'success');
        this.comentarioTicket = '';
        let targets = response.Mensaje.notificacion;
        targets.forEach(e => {
            const target = e.target;
            const id = e.id;
            let notificacionString =  'El usuario ' + this.usuario.userName + ' ha comentado el ticket.';
            let url = 'tickets/'+this.elAidiDelTicket;
            this.sendMessageTest(target, notificacionString, url, id);
        });

        if ( this.usuario.rol !== 'SOPORTE' ) {
          this.usuarioObtenerTickets();
        } else {
          this.soporteObtenerTickets();
        }
        this.detallesTicket(this.elAidiDelTicket);
        this.banderaArchivosImagenes = false;
      }
    }, err => {
      console.log( err );
      Swal('Error' + err.error.error.code, err.error.error.exceltion[0].message, 'error');
    });

  }

  comentarioText()
  {
    const JSONComentario = {
      ticketId: this.elAidiDelTicket,
      comentario: this.comentarioTicket,
    };
    this.network.callSecureService(
      this.API.user.tickets + '/' + this.API.user.comentar,
      'POST',
      JSONComentario
    ).subscribe(( response: any ) => {
     // console.log( response );
      if ( response.Estatus === 201 ) {
        //Swal('Correcto', response.Mensaje.strings, 'success');
        this.comentarioTicket = '';
        let targets = response.Mensaje.notificacion;
        targets.forEach(e => {
            const target = e.target;
            const id = e.id;
            let notificacionString =  'El usuario ' + this.usuario.userName + ' ha comentado el ticket.';
            let url = 'tickets/'+this.elAidiDelTicket;
            this.sendMessageTest(target, notificacionString, url, id);
        });

        if ( this.usuario.rol !== 'SOPORTE' ) {
          this.usuarioObtenerTickets();
        } else {
          this.soporteObtenerTickets();
        }
        this.detallesTicket(this.elAidiDelTicket);
      }
    }, err => {
      console.log( err );
      Swal('Error' + err.error.error.code, err.error.error.exceltion[0].message, 'error');
    });
  }

  adjuntarArchivo(){
    if($('#imagenComentario')[0].files.length > 0){
      this.archivosImagenes = $('#imagenComentario')[0].files;
      this.banderaArchivosImagenes = true;
    }
  }

  ocultarAreaComentario () {
    document.getElementById('AreaDelComentario').style.display = 'none';
  }

  mostrarAreaComentario () {
    document.getElementById('AreaDelComentario').style.display = 'block';
  }

  // Notificaciones
  sendMessageTest(target, notificacionString, url, id) {
    let mensaje = {
      mensaje: notificacionString,
      usuario: this.usuario.userName,
      target: target,
      tipo: 'notificacion',
      url: url,
      id: id
    };
    this.chat.sendMsg(mensaje);
  }

  grafica () {
    this.LineChart = new Chart ('lineChart', {
      type: 'doughnut',
      // type: 'doughnut',
      data: {
        labels: [
          'Pendientes: ' + this.sumaPendientes,
          'Atendiendose: ' + this.sumaAtendidos,
          'Resueltos: ' + this.sumaResueltos,
          'Resueltos y Evaluados: ' + this.sumaResueltosYEvaluados,
        ],
        datasets: [{
          label: 'Number of items',
          data: [ this.sumaPendientes, this.sumaAtendidos, this.sumaResueltos, this.sumaResueltosYEvaluados ],
          fill: false,
          lineTension: 0.2,
          // borderColor: 'red',
          backgroundColor: [
            'rgba(44, 162, 235, 0.2)',
            'rgba(255, 153, 0, 0.2)',
            'rgba(71, 209, 71, 0.2)',
            'rgba(102, 153, 0, 0.2)',
          ],
          borderColor: [
            'rgba(44, 162, 235, 1)',
            'rgba(255, 153, 0, 1)',
            'rgba(71, 209, 71, 1)',
            'rgba(102, 153, 0, 1)',
          ],
          borderWidth: 1
        }]
      },
      options: {
        title: {
          text: 'Tickets: ' + this.ticketsTotal,
          display: true
        },
      }
    });

    this.LineChart2 = new Chart ('lineChart2', {
      type: 'bar',
      // type: 'doughnut',
      data: {
        labels: [
          'Porcentaje tiempo: ' + this.sumaTiempoConcepto.toFixed(2),
          'Cumplimiento: ' + this.sumaCumplimiento.toFixed(2),
          'PorcentajeEncuesta: ' + this.sumaPorcentajeEncuesta.toFixed(2)
        ],
        datasets: [{
          label: 'Porcentaje de Sistemas Total:  ' + this.procentajeTotal.toFixed(2),
          data: [this.sumaTiempoConcepto, this.sumaCumplimiento, this.sumaPorcentajeEncuesta],
          fill: false,
          lineTension: 0.2,
          // borderColor: 'red',
          backgroundColor: [
            'rgba(0, 153, 255, 0.2)',
            'rgba(0, 153, 0, 0.2)',
            'rgba(41, 82, 163, 0.2)',
          ],
          borderColor: [
            'rgba(0, 153, 255, 1)',
            'rgba(0, 153, 0, 1)',
            'rgba(41, 82, 163, 1)',
          ],
          borderWidth: 1
        }]
      },
      options: {
        title: {
          text: 'Tickets',
          display: true
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    });
  }
  // GRAFICA

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/sistemas/sistema-tickets/sistema-tickets.component.ts